<template>
  <v-card class="rounded-xl elevation-2">
    <!-- Header Premium -->
    <div class="modern-header-detail">
      <div class="header-content-detail">
        <div class="header-left-detail">
          <v-icon class="header-icon-detail" size="32" color="white"
            >mdi-briefcase-check</v-icon
          >
          <div class="header-text">
            <h2 class="header-title-detail">
              Requerimiento de Personal #{{ requirement.ReqID }}
            </h2>
            <p class="header-subtitle">{{ requirement.CmpName }}</p>
          </div>
        </div>
        <div class="header-actions-detail">
          <v-chip
            :color="getStatusColor(requirement.ReqStatus)"
            text-color="white"
            class="mr-2"
          >
            {{ requirement.ReqStatusName || "En Creación" }}
          </v-chip>
          <v-btn icon large class="close-btn" @click="$emit('close')">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <v-container fluid class="px-6 pt-6 pb-4">
      <!-- Loading state -->
      <div v-if="loading" class="text-center py-8">
        <v-progress-circular indeterminate color="primary" size="50" />
        <p class="mt-3 grey--text text-caption">Cargando información...</p>
      </div>

      <!-- Main content -->
      <template v-if="!loading && requirement.ReqID">
        <v-row>
          <!-- Left column: Basic info -->
          <v-col cols="12" md="8">
            <!-- Sección: Información Básica -->
            <v-card outlined class="mb-4 section-card">
              <v-card-title class="section-title">
                <v-icon small class="mr-2" color="#04abc5"
                  >mdi-information</v-icon
                >
                Información Básica
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="section-content">
                <div class="basic-info-grid">
                  <div class="info-item-box">
                    <v-icon class="field-icon" color="primary"
                      >mdi-office-building</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Área</span>
                      <span class="value">{{ requirement.AreName }}</span>
                    </div>
                  </div>
                  <div class="info-item-box">
                    <v-icon class="field-icon" color="primary"
                      >mdi-account-tie</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Cargo Solicitado</span>
                      <span class="value">{{ requirement.PstName }}</span>
                    </div>
                  </div>
                  <div class="info-item-box">
                    <v-icon class="field-icon" color="primary"
                      >mdi-bullhorn</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Campaña</span>
                      <span class="value">{{ requirement.CmpName }}</span>
                    </div>
                  </div>
                  <div class="info-item-box">
                    <v-icon class="field-icon" color="primary"
                      >mdi-file-tree</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Tipo de Requerimiento</span>
                      <span class="value">{{
                        requirement.TypeRequirementName
                      }}</span>
                    </div>
                  </div>
                  <div class="info-item-box">
                    <v-icon class="field-icon" color="primary"
                      >mdi-account-multiple</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Cantidad Requerida</span>
                      <span
                        class="value text-h5 primary--text font-weight-bold"
                        >{{ requirement.ReqQuantity }}</span
                      >
                    </div>
                  </div>
                  <div class="info-item-box" v-if="requirement.TypeSeekingName">
                    <v-icon class="field-icon" color="primary"
                      >mdi-magnify</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Tipo de Cobertura</span>
                      <span class="value">{{
                        requirement.TypeSeekingName
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="info-item-box"
                    v-if="requirement.TypeLaborRegimeName"
                  >
                    <v-icon class="field-icon" color="primary"
                      >mdi-scale-balance</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Régimen Laboral</span>
                      <span class="value">{{
                        requirement.TypeLaborRegimeName
                      }}</span>
                    </div>
                  </div>
                  <div class="info-item-box" v-if="requirement.TypePayrollName">
                    <v-icon class="field-icon" color="primary"
                      >mdi-card-text-outline</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Tipo de Planilla</span>
                      <span class="value">{{
                        requirement.TypePayrollName
                      }}</span>
                    </div>
                  </div>
                  <div class="info-item-box" v-if="requirement.CceName">
                    <v-icon class="field-icon" color="primary"
                      >mdi-calculator</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Centro de Costo</span>
                      <span class="value">{{ requirement.CceName }}</span>
                    </div>
                  </div>
                  <div class="info-item-box" v-if="requirement.ReqEndContract">
                    <v-icon class="field-icon" color="primary"
                      >mdi-calendar-range</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Fin Contrato</span>
                      <span class="value">{{
                        $fun.formatDateView(requirement.ReqEndContract)
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="info-item-box info-item-box--full"
                    v-if="requirement.ReqPaymentType !== null && isAdmin"
                  >
                    <v-icon class="field-icon" color="primary"
                      >mdi-cash-multiple</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Sueldo / Compensación</span>
                      <div class="salary-details-box mt-1">
                        <span
                          v-if="requirement.ReqPaymentType === 1"
                          class="value font-weight-bold"
                        >
                          {{
                            getBudgetDisplayValue(requirement.ReqPayValue1)
                              ? formatCurrency(
                                  getBudgetDisplayValue(
                                    requirement.ReqPayValue1,
                                  ),
                                )
                              : "N/A"
                          }}
                          (Monto Fijo)
                        </span>
                        <div
                          v-else-if="
                            [2, 3].includes(Number(requirement.ReqPaymentType))
                          "
                          class="d-flex flex-wrap gap-3"
                        >
                          <span class="value mr-4">
                            <strong>
                              {{
                                requirement.ReqPaymentType === 2
                                  ? "Mínimo"
                                  : "Nivel A"
                              }}
                              :</strong
                            >
                            {{
                              getBudgetDisplayValue(requirement.ReqPayValue1)
                                ? formatCurrency(
                                    getBudgetDisplayValue(
                                      requirement.ReqPayValue1,
                                    ),
                                  )
                                : "N/A"
                            }}
                          </span>
                          <span
                            class="value mr-4"
                            v-if="requirement.ReqPaymentType === 2"
                          >
                            <strong>Máximo:</strong>
                            {{
                              getBudgetDisplayValue(requirement.ReqPayValue2)
                                ? formatCurrency(
                                    getBudgetDisplayValue(
                                      requirement.ReqPayValue2,
                                    ),
                                  )
                                : "N/A"
                            }}
                          </span>
                          <span
                            class="value mr-4"
                            v-if="requirement.ReqPaymentType === 3"
                          >
                            <strong>Nivel B:</strong>
                            {{
                              getBudgetDisplayValue(requirement.ReqPayValue2)
                                ? formatCurrency(
                                    getBudgetDisplayValue(
                                      requirement.ReqPayValue2,
                                    ),
                                  )
                                : "N/A"
                            }}
                          </span>
                          <span
                            class="value"
                            v-if="requirement.ReqPaymentType === 3"
                          >
                            <strong>Nivel C:</strong>
                            {{
                              getBudgetDisplayValue(requirement.ReqPayValue3)
                                ? formatCurrency(
                                    getBudgetDisplayValue(
                                      requirement.ReqPayValue3,
                                    ),
                                  )
                                : "N/A"
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="info-item-box info-item-box--full"
                    v-if="requirement.ReqObservation"
                  >
                    <v-icon class="field-icon" color="primary"
                      >mdi-comment-text-outline</v-icon
                    >
                    <div class="field-content">
                      <span class="label">Comentarios / Observaciones</span>
                      <span class="value">{{ requirement.ReqObservation }}</span>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <!-- Sección: Distribución / Dimensionamiento de Personal (Solo Masivo) -->
            <v-card
              v-if="isCampaignType(requirement)"
              outlined
              class="mb-4 section-card"
            >
              <v-card-title class="section-title">
                <v-icon small class="mr-2" color="#04abc5"
                  >mdi-calendar-multiselect</v-icon
                >
                Distribución Semanal de Personal (Dimensionamiento)
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="section-content">
                <div
                  v-if="
                    !requirement.Projections ||
                    requirement.Projections.length === 0
                  "
                  class="grey--text text-center py-4"
                >
                  <v-icon>mdi-calendar-blank-outline</v-icon>
                  <p class="mt-2">Sin proyecciones semanales configuradas</p>
                </div>
                <div v-else>
                  <!-- Resumen Totales agrupados -->
                  <div class="projection-summary-card">
                    <div class="summary-card-title">
                      <v-icon small class="mr-1" color="#475569"
                        >mdi-chart-pie</v-icon
                      >
                      Resumen Total por Semana
                    </div>
                    <div class="summary-grid">
                      <div
                        v-for="totalRow in getWeeklyTotals(requirement)"
                        :key="totalRow.PdsID"
                        class="summary-badge"
                      >
                        <span class="summary-week">{{
                          getPeriodName(totalRow.PdsID)
                        }}</span>
                        <div class="summary-details">
                          <span class="summary-qty-total">
                            <strong>{{ totalRow.total }}</strong> /
                            {{ requirement.ReqQuantity }}
                          </span>
                          <span class="summary-qty-split">
                            ({{ totalRow.male }}
                            <v-icon x-small color="#3b82f6" class="mx-0.5"
                              >mdi-gender-male</v-icon
                            >
                            /
                            {{ totalRow.female }}
                            <v-icon x-small color="#ec4899" class="mx-0.5"
                              >mdi-gender-female</v-icon
                            >)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <!-- Sección: Cronograma de Ingreso Estimado (Reclutamiento Profesional) -->
            <v-card
              v-if="!isCampaignType(requirement)"
              outlined
              class="mb-4 section-card"
            >
              <v-card-title class="section-title">
                <v-icon small class="mr-2" color="#04abc5"
                  >mdi-calendar-clock</v-icon
                >
                Cronograma de Ingreso Estimado
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="section-content">
                <div
                  v-if="
                    !requirement.ProfessionalSchedules ||
                    requirement.ProfessionalSchedules.filter(
                      (p) => p.SecStatus !== 0,
                    ).length === 0
                  "
                  class="grey--text text-center py-4"
                >
                  <v-icon>mdi-calendar-blank-outline</v-icon>
                  <p class="mt-2">
                    Sin cronograma de ingreso estimado configurado
                  </p>
                </div>
                <div v-else>
                  <v-simple-table dense class="mb-3">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left font-weight-bold">
                            Fecha Estimada
                          </th>
                          <th class="text-center font-weight-bold">
                            Cantidad Estimada
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(
                            row, idx
                          ) in requirement.ProfessionalSchedules.filter(
                            (p) => p.SecStatus !== 0,
                          )"
                          :key="row.PscID || idx"
                        >
                          <td>
                            {{
                              row.PscEstimatedDate
                                ? $fun.formatDateView(row.PscEstimatedDate)
                                : "N/A"
                            }}
                          </td>
                          <td
                            class="text-center font-weight-bold primary--text"
                          >
                            {{ row.PscQuantityProject }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <div
                    class="d-flex align-center justify-space-between px-1 text-caption"
                  >
                    <span>
                      <strong>Total Estimado:</strong>
                      {{ getDistributedTotal(requirement) }} /
                      {{ requirement.ReqQuantity }} vacantes
                    </span>
                    <v-chip
                      x-small
                      :color="
                        getDistributedTotal(requirement) ===
                        Number(requirement.ReqQuantity)
                          ? 'success'
                          : 'warning'
                      "
                      outlined
                    >
                      {{
                        getDistributedTotal(requirement) ===
                        Number(requirement.ReqQuantity)
                          ? "Completo"
                          : "Parcial"
                      }}
                    </v-chip>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <!-- Sección: Circuito de Aprobación -->
            <v-card outlined class="mb-4 section-card">
              <v-card-title class="section-title">
                <v-icon small class="mr-2">mdi-check-decagram</v-icon>
                Circuito de Aprobación
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="section-content">
                <div
                  v-if="approvalList.length === 0"
                  class="grey--text text-center py-4"
                >
                  <v-icon>mdi-information-outline</v-icon>
                  <p class="mt-2">Sin circuito configurado aún</p>
                </div>
                <v-timeline v-else :dense="true" class="approval-timeline">
                  <v-timeline-item
                    v-for="approval in approvalList"
                    :key="approval.RapID"
                    :color="getApprovalColor(approval.RapStatus)"
                    small
                  >
                    <template v-slot:opposite>
                      <span class="timeline-order"
                        >Nivel {{ approval.RapApprovalOrd }}</span
                      >
                    </template>

                    <v-card
                      :outlined="approval.RapStatus === 2"
                      :color="
                        approval.RapStatus === 2
                          ? 'blue lighten-5'
                          : approval.RapStatus === 4
                          ? 'green lighten-5'
                          : approval.RapStatus === 3
                          ? 'red lighten-5'
                          : 'grey lighten-5'
                      "
                      class="approval-card"
                    >
                      <v-card-text>
                        <div
                          class="d-flex justify-space-between align-center mb-2"
                        >
                          <strong>{{ approval.PstName }}</strong>
                          <v-chip
                            :color="getStatusColor(approval.RapStatus)"
                            text-color="white"
                            x-small
                          >
                            {{ getStatusText(approval.RapStatus) }}
                          </v-chip>
                        </div>
                        <p class="text-caption grey--text">
                          {{ approval.PrsName || "Pendiente" }}
                        </p>
                        <p
                          v-if="approval.RapApprovalDT"
                          class="text-caption grey--text"
                        >
                          {{ $fun.formatDateTimeView(approval.RapApprovalDT) }}
                        </p>
                        <p
                          v-if="approval.RapObservation"
                          class="text-caption mt-2 orange--text"
                        >
                          📝 {{ approval.RapObservation }}
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Right column: Summary -->
          <v-col cols="12" md="4">
            <!-- Summary Card -->
            <v-card outlined class="section-card sticky-summary">
              <v-card-title class="section-title">
                <v-icon small class="mr-2">mdi-file-document</v-icon>
                Resumen
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="section-content">
                <div class="summary-item">
                  <span class="label">ID Requerimiento</span>
                  <span class="value font-weight-bold">{{
                    requirement.ReqID
                  }}</span>
                </div>
                <v-divider class="my-2"></v-divider>

                <div class="summary-item">
                  <span class="label">Estado Actual</span>
                  <v-chip
                    :color="getStatusColor(requirement.ReqStatus)"
                    text-color="white"
                    small
                    class="mt-1"
                  >
                    {{ requirement.ReqStatusName }}
                  </v-chip>
                </div>
                <v-divider class="my-2"></v-divider>

                <div class="summary-item">
                  <span class="label">Solicitado por</span>
                  <span class="value text-caption">{{
                    requirement.RequesterName
                  }}</span>
                </div>
                <v-divider class="my-2"></v-divider>

                <div class="summary-item">
                  <span class="label">Fecha de Creación</span>
                  <span class="value text-caption">
                    {{ $fun.formatDateTimeView(requirement.SecCreate) }}
                  </span>
                </div>
                <v-divider class="my-2"></v-divider>

                <div class="summary-item">
                  <span class="label">Aprobaciones Pendientes</span>
                  <v-chip color="primary" text-color="white" small class="mt-1">
                    {{ countPending() }}
                  </v-chip>
                </div>

                <v-divider class="mt-4 mb-3"></v-divider>

                <!-- Action buttons -->
                <template v-if="canApproveOrReject">
                  <!-- Campo Presupuesto/Sueldo Base (solo admins y encargado de presupuesto) -->
                  <!-- <s-text
                    v-if="canViewBudgetField"
                    v-model="reqEstBudget"
                    label="Sueldo Base"
                    type="number"
                    step="0.01"
                    min="0"
                    outlined
                    dense
                    :readonly="isBudgetReadOnly"
                    :required="isValBudgetPerson"
                    :rules="isValBudgetPerson ? [(v) => v > 0 || 'Campo requerido'] : []"
                    prefix="S/"
                    class="mb-3"
                    hide-details
                  /> -->
                  <v-row class="mb-2" v-if="isValBudgetPerson">
                    <v-col cols="12" md="12">
                      <s-select
                        v-model="reqPaymentType"
                        :items="paymentTypeOptions"
                        item-text="label"
                        item-value="value"
                        label="Tipo de Compensación"
                        outlined
                        dense
                        clearable
                        :disabled="!isValBudgetPerson"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12" md="4" v-if="reqPaymentType">
                      <s-text
                        v-model="payValue1"
                        :label="payValue1Label"
                        decimal
                        prefix="S/"
                        :disabled="!isValBudgetPerson"
                        hide-details
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      v-if="[2, 3].includes(Number(reqPaymentType))"
                    >
                      <s-text
                        v-model="payValue2"
                        :label="payValue2Label"
                        decimal
                        prefix="S/"
                        :disabled="!isValBudgetPerson"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12" md="4" v-if="Number(reqPaymentType) === 3">
                      <s-text
                        v-model="payValue3"
                        label="Nivel C"
                        decimal
                        prefix="S/"
                        :disabled="!isValBudgetPerson"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mb-2" v-if="isValBudgetPerson">
                    <v-col cols="12" md="6">
                      <s-select-area
                        v-model="cceID"
                        :text="cceName"
                        centercost
                        clearable
                        :disabled="!isValBudgetPerson"
                        label="Centro de Costo"
                      />
                    </v-col>
                    <!-- <v-col cols="12" md="6">
                      <s-select-business-line :cceID="cceID || 0" v-model="bslID" :text="bslName"
                        :disabled="!isValBudgetPerson" label="Línea de Negocio" />
                    </v-col> -->
                  </v-row>
                  <v-row class="mb-2" v-if="isValBudgetPerson">
                    <v-col cols="12" md="12" style="padding-bottom: 0px">
                      <s-select-definition
                        v-if="canViewBudgetField"
                        :def="1060"
                        label="Tipo de Planilla"
                        v-model="typePayroll"
                        class="mb-3"
                      />
                    </v-col>
                    <v-col cols="12" md="12" style="padding-top: 0px">
                      <s-select-definition
                        v-if="canViewBudgetField"
                        :def="1481"
                        label="Régimen Laboral"
                        v-model="typeLaborRegime"
                        class="mb-3"
                      />
                    </v-col>
                  </v-row>
                  <v-textarea
                    v-model="observation"
                    label="Observación"
                    outlined
                    dense
                    rows="3"
                    hint="Requerido para rechazar"
                    class="mb-3"
                    hide-details
                  ></v-textarea>

                  <v-btn
                    block
                    small
                    color="success"
                    @click="approve"
                    :loading="processing"
                    class="mb-2"
                  >
                    <v-icon left small>mdi-check-circle</v-icon>
                    Aprobar
                  </v-btn>

                  <v-btn
                    block
                    small
                    color="error"
                    @click="reject"
                    :loading="processing"
                  >
                    <v-icon left small>mdi-close-circle</v-icon>
                    Rechazar
                  </v-btn>
                </template>
                <template v-else>
                  <v-alert type="info" dense outlined class="text-caption">
                    <v-icon x-small>mdi-information</v-icon>
                    No tienes un nivel pendiente en este circuito
                  </v-alert>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <!-- Empty state -->
      <template v-if="!loading && !requirement.ReqID">
        <v-alert type="warning" dense outlined>
          No se encontró la información del requerimiento
        </v-alert>
      </template>
    </v-container>
  </v-card>
</template>

<script>
import _sStaffingRequirement from "@/services/HumanResource/RecruitmentSelection/HmnStaffingRequirement.js";
import _sApproval from "@/services/HumanResource/RecruitmentSelection/HmnRequirementApprovalService.js";
import _sGenParam from "@/services/General/ParameterService";
import _sAuth from "@/services/AuthService";
import _sCreationPeriods from "@/services/HumanResource/CreationPeriods";

export default {
  name: "HmnStaffingRequirementDetail",
  props: {
    reqID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      processing: false,
      routeSecurity: null,
      requirement: {
        ReqID: 0,
      },
      approvalList: [],
      observation: "",
      valBudgetPstID: 0,
      reqPaymentType: null,
      payValue1: null,
      payValue2: null,
      payValue3: null,
      cceID: null,
      bslID: null,
      bslName: "",
      cceName: "",
      paymentTypeOptions: [
        { value: 1, label: "Monto Fijo" },
        { value: 2, label: "Rango (mín - máx)" },
        { value: 3, label: "Por Niveles (A / B / C)" },
      ],
      typePayroll: null,
      typeLaborRegime: null,
      periodsList: [],
      periodYear: new Date().getFullYear(),
    };
  },
  computed: {
    isAdmin() {
      if (this.routeSecurity && this.routeSecurity.IsLevelAdmin !== undefined) {
        return !!this.routeSecurity.IsLevelAdmin;
      }
      return this.$fun.isAdmin();
    },
    userPstID() {
      const info = this.$fun.getUserInfo();
      return info && info.CtrContract ? info.CtrContract.PstID : 0;
    },
    isValBudgetPerson() {
      //console.log("budget positions",this.valBudgetPstID);

      const budgetPositions = Array.isArray(this.valBudgetPstID)
        ? this.valBudgetPstID.map((id) => Number(id))
        : [];
      //console.log("checking budgetPositions", budgetPositions);

      return budgetPositions.includes(Number(this.userPstID));
    },
    canViewBudgetField() {
      return this.isValBudgetPerson || this.isAdmin;
    },
    payValue1Label() {
      if (this.reqPaymentType === 1) return "Monto Fijo";
      if (this.reqPaymentType === 2) return "M\u00ednimo";
      if (this.reqPaymentType === 3) return "Nivel A";
      return "Valor";
    },
    payValue2Label() {
      if (this.reqPaymentType === 2) return "M\u00e1ximo";
      if (this.reqPaymentType === 3) return "Nivel B";
      return "Valor 2";
    },
    isBudgetReadOnly() {
      return this.isAdmin && !this.isValBudgetPerson;
    },
    currentPendingLevel() {
      return this.approvalList.find((a) => a.RapStatus === 2) || null;
    },
    canApproveOrReject() {
      if (!this.currentPendingLevel) return false;
      return this.currentPendingLevel.ApprovalPstID === this.userPstID;
    },
  },
  methods: {
    loadRouteSecurity() {
      const routeSecurity = this.$route?.params?.security;
      if (routeSecurity && routeSecurity.UsoID != null) {
        this.routeSecurity = routeSecurity;
        return;
      }

      _sAuth
        .userOption(this.$fun.getUserID(), "HMN_STAFFING_REQUIREMENT")
        .then((r) => {
          if (r && r.data) {
            this.routeSecurity = r.data;
          }
        })
        .catch(() => {
          this.routeSecurity = null;
        });
    },
    loadRequirement() {
      this.loading = true;
      _sStaffingRequirement
        .byID(this.reqID, this.$fun.getUserID())
        .then((r) => {
          if (r.data) {
            console.log("stafing requirement by reqid", r.data);

            this.requirement = r.data;
            this.reqPaymentType = this.requirement.ReqPaymentType || null;
            this.payValue1 = this.getBudgetDisplayValue(
              this.requirement.ReqPayValue1,
            );
            this.payValue2 = this.getBudgetDisplayValue(
              this.requirement.ReqPayValue2,
            );
            this.payValue3 = this.getBudgetDisplayValue(
              this.requirement.ReqPayValue3,
            );
            this.cceID = this.requirement.CceID || null;
            //this.bslID = this.requirement.BslID || null;
            //this.bslName = this.requirement.BslName || "";
            this.cceName = this.requirement.CceName || "";
            this.typePayroll = this.requirement.TypePayroll || null;
            this.typeLaborRegime = this.requirement.TypeLaborRegime || null;
          }
        })
        .catch((r) => {
          this.$fun.alert(r, "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadApprovals() {
      Promise.all([
        _sApproval.byReqID(this.reqID, this.$fun.getUserID()),
        _sGenParam.search(
          { PrmName: "ValBudgetPstID_RRHH" },
          this.$fun.getUserID(),
        ),
      ])
        .then((results) => {
          this.approvalList = results[0].data || [];
          const budgetParam = results[1].data || {};
          const budgetValue = (budgetParam.PrmValue || "").trim();
          this.valBudgetPstID = budgetValue
            ? budgetValue
                .split(",")
                .map((id) => parseInt(id.trim(), 10))
                .filter((id) => !Number.isNaN(id))
            : [];
          console.log(
            "ValBudgetPstID_RRHH param",
            budgetParam,
            "parsed as",
            this.valBudgetPstID,
          );
        })
        .catch(() => {
          this.approvalList = [];
        });
      console.log(
        "lista de aprobaciones",
        this.approvalList,
        "valBudgetPstID",
        this.valBudgetPstID,
      );
    },
    countPending() {
      return this.approvalList.filter((a) => a.RapStatus === 2).length;
    },
    getStatusColor(status) {
      switch (status) {
        case 1:
          return "grey";
        case 2:
          return "primary";
        case 3:
          return "error";
        case 4:
          return "success";
        case 5:
          return "success";
        case 6:
          return "blue-grey";
        case 7:
          return "error";
        default:
          return "grey";
      }
    },
    getStatusText(status) {
      switch (status) {
        case 1:
          return "No asignado";
        case 2:
          return "Pendiente";
        case 3:
          return "Rechazado";
        case 4:
          return "Aprobado";
        case 5:
          return "Aprobado / Vigente";
        case 6:
          return "Ampliado / Reemplazado";
        case 7:
          return "Desaprobado";
        default:
          return "Desconocido";
      }
    },
    getApprovalColor(status) {
      switch (status) {
        case 2:
          return "info";
        case 3:
          return "error";
        case 4:
          return "success";
        default:
          return "grey";
      }
    },
    formatCurrency(value) {
      if (value === null || value === undefined || value === "" || Number.isNaN(Number(value))) {
        return "PEN 0.00";
      }
      return new Intl.NumberFormat("es-SV", {
        style: "currency",
        currency: "PEN",
      }).format(Number(value));
    },
    getBudgetDisplayValue(value) {
      if (value === null || value === undefined || value === "") return null;

      const numericValue = Number(value);
      if (!Number.isNaN(numericValue) && String(value).trim() !== "") {
        return numericValue;
      }

      try {
        const decryptedValue = this.$fun.decrypt(value);
        const parsedValue = Number(decryptedValue);
        return Number.isNaN(parsedValue) ? null : parsedValue;
      } catch (error) {
        return null;
      }
    },
    getBudgetEncryptedValue(value) {
      if (value === null || value === undefined || value === "") return null;
      const numericValue = this.getBudgetDisplayValue(value);
      if (numericValue === null || Number.isNaN(numericValue) || numericValue <= 0) return null;
      return this.$fun.encrypt(numericValue.toString());
    },
    approve() {
      // Si es el encargado de presupuesto, validar que lo haya llenado
      if (
        this.isValBudgetPerson &&
        (!this.reqPaymentType || this.reqPaymentType <= 0)
      ) {
        this.$fun.alert(
          "Debe ingresar el tipo de compensación antes de aprobar",
          "warning",
        );
        return;
      }
      if (this.isValBudgetPerson && !this.typePayroll) {
        this.$fun.alert(
          "Debe seleccionar tipo de planilla antes de aprobar",
          "warning",
        );
        return;
      }
      if (this.isValBudgetPerson && !this.typeLaborRegime) {
        this.$fun.alert(
          "Debe seleccionar régimen laboral antes de aprobar",
          "warning",
        );
        return;
      }
      if (this.isValBudgetPerson && (!this.payValue1 || this.payValue1 <= 0)) {
        this.$fun.alert(
          `Debe ingresar el valor ${this.payValue1Label} antes de aprobar`,
          "warning",
        );
        return;
      }
      if (
        this.isValBudgetPerson &&
        [2, 3].includes(Number(this.reqPaymentType)) &&
        (!this.payValue2 || this.payValue2 <= 0)
      ) {
        this.$fun.alert(
          `Debe ingresar el valor ${this.payValue2Label} antes de aprobar`,
          "warning",
        );
        return;
      }
      if (
        this.isValBudgetPerson &&
        Number(this.reqPaymentType) === 3 &&
        (!this.payValue3 || this.payValue3 <= 0)
      ) {
        this.$fun.alert(
          `Debe ingresar el valor ${this.payValue3Label} antes de aprobar`,
          "warning",
        );
        return;
      }
      this.$fun.alert("¿Aprobar este nivel?", "question").then((result) => {
        if (!result?.isConfirmed) return;
        this.processing = true;
        _sApproval
          .approve(
            {
              RapID: this.currentPendingLevel.RapID,
              RapStatus: 4,
              RapObservation: this.observation,
              ReqEstBudget: this.isValBudgetPerson
                ? this.getBudgetEncryptedValue(this.payValue1)
                : null,
              ReqPaymentType: this.isValBudgetPerson
                ? this.reqPaymentType
                : null,
              ReqPayValue1: this.isValBudgetPerson
                ? this.getBudgetEncryptedValue(this.payValue1)
                : null,
              ReqPayValue2:
                this.isValBudgetPerson &&
                [2, 3].includes(Number(this.reqPaymentType))
                  ? this.getBudgetEncryptedValue(this.payValue2)
                  : null,
              ReqPayValue3:
                this.isValBudgetPerson && Number(this.reqPaymentType) === 3
                  ? this.getBudgetEncryptedValue(this.payValue3)
                  : null,
              TypePayroll: this.isValBudgetPerson ? this.typePayroll : null,
              TypeLaborRegime: this.isValBudgetPerson
                ? this.typeLaborRegime
                : null,
              CceID: this.isValBudgetPerson ? this.cceID : null,
              //BslID: this.isValBudgetPerson ? this.bslID : null,
              ReqID: this.reqID,
            },
            this.$fun.getUserID(),
          )
          .then(() => {
            this.$fun.alert("Aprobado correctamente", "success");
            this.observation = "";
            this.reqEstBudget = 0;
            this.reqPayValue1 = 0;
            this.reqPayValue2 = 0;
            this.reqPayValue3 = 0;
            this.$emit("saved");
            this.loadApprovals();
          })
          .catch((e) => {
            this.$fun.alert(e || "Error al aprobar", "error");
          })
          .finally(() => {
            this.processing = false;
          });
      });
    },
    reject() {
      if (!this.observation || this.observation.trim() === "") {
        this.$fun.alert(
          "Debe ingresar una observación para rechazar",
          "warning",
        );
        return;
      }
      this.$fun
        .alert("¿Rechazar este requerimiento?", "question")
        .then((result) => {
          if (!result?.isConfirmed) return;
          this.processing = true;
          _sApproval
            .approve(
              {
                RapID: this.currentPendingLevel.RapID,
                RapStatus: 3,
                RapObservation: this.observation,
              },
              this.$fun.getUserID(),
            )
            .then(() => {
              this.$fun.alert("Requerimiento rechazado", "success");
              this.observation = "";
              this.$emit("saved");
              this.$emit("close");
            })
            .catch((e) => {
              this.$fun.alert(e || "Error al rechazar", "error");
            })
            .finally(() => {
              this.processing = false;
            });
        });
    },
    loadPeriods() {
      _sCreationPeriods
        .list(1, this.periodYear, this.$fun.getUserID())
        .then((r) => {
          this.periodsList = r.data || [];
        })
        .catch(() => {});
    },
    getPeriodName(pdsID) {
      if (!pdsID) return "";
      const period = this.periodsList.find(
        (p) => String(p.PdsID) === String(pdsID),
      );
      return period ? period.PdsName : `Semana ${pdsID}`;
    },
    getTurnText(type) {
      if (type === 1) return "DIURNO";
      if (type === 2) return "NOCTURNO";
      return "SIN ASIGNAR";
    },
    getWeeklyTotals(item) {
      if (!item || !item.Projections) return [];

      const activeProjections = item.Projections.filter(
        (p) => p.SecStatus !== 0 && p.PdsID,
      );

      const groups = {};
      activeProjections.forEach((p) => {
        const key = p.PdsID;
        if (!groups[key]) {
          groups[key] = {
            PdsID: key,
            total: 0,
            male: 0,
            female: 0,
          };
        }
        groups[key].total += Number(p.WprQuantityProject) || 0;
        groups[key].male += Number(p.WprQuantityMale) || 0;
        groups[key].female += Number(p.WprQuantityFemale) || 0;
      });

      return Object.values(groups);
    },
    isCampaignType(item) {
      const campaignType = 2; // Campaign / Masivo
      return Number(item.TypeRequirement) === Number(campaignType);
    },
    getDistributedTotal(item) {
      if (!item) return 0;
      if (this.isCampaignType(item)) {
        if (!item.Projections) return 0;
        return item.Projections.filter((p) => p.SecStatus !== 0).reduce(
          (sum, p) => sum + (Number(p.WprQuantityProject) || 0),
          0,
        );
      } else {
        if (!item.ProfessionalSchedules) return 0;
        return item.ProfessionalSchedules.filter(
          (p) => p.SecStatus !== 0,
        ).reduce((sum, p) => sum + (Number(p.PscQuantityProject) || 0), 0);
      }
    },
  },
  created() {
    this.loadRouteSecurity();
    this.loadRequirement();
    this.loadApprovals();
    this.loadPeriods();
  },
};
</script>

<style scoped>
/* Header premium */
.modern-header-detail {
  background: linear-gradient(135deg, #04abc5 0%, #00a3ba 100%);
  padding: 12px;
  color: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 12px 12px 0 0;
}

.header-content-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left-detail {
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1;
}

.header-icon-detail {
  background: rgba(255, 255, 255, 0.2);
  padding: 12px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.header-text {
  flex: 1;
}

.header-title-detail {
  font-size: 1.2rem;
  margin: 0;
  font-weight: 600;
}

.header-subtitle {
  font-size: 0.85rem;
  margin: 4px 0 0 0;
  opacity: 0.85;
}

.header-actions-detail {
  display: flex;
  gap: 8px;
  align-items: center;
}

.close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Section styling */
.section-card {
  border: 1px solid #e8eef5 !important;
  border-radius: 8px;
  transition: all 0.2s ease;
  text-transform: uppercase;
}

.section-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.section-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #04abc5;
  font-size: 0.95rem;
  padding: 12px 16px !important;
}

.section-content {
  padding: 12px 16px !important;
}

.info-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.info-field .label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-field .value {
  font-size: 0.95rem;
  color: #222;
  font-weight: 500;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-item .label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-item .value {
  font-size: 0.9rem;
  color: #333;
  font-weight: 500;
}

.sticky-summary {
  position: sticky;
  top: 60px;
}

/* Timeline */
.approval-timeline {
  padding: 8px 0;
}

.timeline-order {
  font-size: 0.8rem;
  font-weight: 600;
  color: #999;
  text-align: right;
  padding-right: 12px;
}

.approval-card {
  border-radius: 6px !important;
  transition: all 0.2s ease;
}

.approval-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Rediseño Moderno Información Básica */
.basic-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.info-item-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  transition: all 0.2s ease;
}

.info-item-box:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.info-item-box--full {
  grid-column: 1 / -1;
}

.field-icon {
  background: #e0f2fe;
  padding: 8px;
  border-radius: 8px;
}

.field-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.field-content .label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.field-content .value {
  font-size: 13px;
  color: #0f172a;
  font-weight: 600;
}

.salary-details-box {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 12px;
  display: inline-block;
}

.gap-3 {
  gap: 12px;
}

/* Proyecciones Semanales Detail */
.projection-detail-table {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.projection-detail-header {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr 1.2fr;
  background: #f8fafc;
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  border-bottom: 1px solid #cbd5e1;
}

.projection-detail-row {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr 1.2fr;
  padding: 10px 14px;
  font-size: 13px;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;
}

.projection-detail-row:last-child {
  border-bottom: none;
}

.projection-summary-card {
  /* margin-top: 16px; */
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  padding: 10px;
}

.summary-card-title {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.summary-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.summary-badge {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
  min-width: 140px;
}

.summary-week {
  font-size: 11px;
  font-weight: 700;
  color: #3b5bdb;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 4px;
}

.summary-details {
  display: flex;
  flex-direction: column;
}

.summary-qty-total {
  font-size: 13px;
  color: #1e293b;
}

.summary-qty-split {
  font-size: 11px;
  color: #64748b;
  display: flex;
  align-items: center;
  margin-top: 2px;
}
</style>
